import {ReactElement} from "react"

const FriendIcon = ({disabled}: {disabled?: boolean}): ReactElement => {
	return (
    <svg width="44" height="29" viewBox="0 0 44 29" fill="none" xmlns="http://www.w3.org/2000/svg" className="friend-icon">
      <path
        d="M9.41028 12C12.861 12.0001 15.7971 14.5151 16.3273 17.9248L16.6085 19.7402C17.8496 18.6508 19.4726 18 21.2267 18H22.4103C24.1506 18 25.7594 18.6404 26.9952 19.7119L27.3312 17.7939C27.9171 14.4442 30.826 12 34.2267 12H35.4103C38.861 12.0001 41.7971 14.5151 42.3273 17.9248L43.4152 24.9248C44.0748 29.1684 40.7928 33 36.4982 33H33.0021C32.1077 33 31.2589 32.8312 30.4796 32.5303C30.2151 36.0883 27.2419 39 23.4982 39H20.0021C16.2511 39 13.2854 36.0807 13.0216 32.5293C12.2417 32.8306 11.3923 33 10.4982 33H7.00208C2.65377 33 -0.642613 29.0772 0.106567 24.7939L1.33118 17.7939C1.91714 14.4442 4.82604 12 8.22668 12H9.41028ZM21.671 6C24.9847 6 27.671 8.68629 27.671 12C27.671 15.3137 24.9847 18 21.671 18C18.3574 17.9999 15.671 15.3137 15.671 12C15.671 8.68633 18.3574 6.00006 21.671 6ZM8.67102 0C11.9847 0 14.671 2.68629 14.671 6C14.671 9.31371 11.9847 12 8.67102 12C5.35737 11.9999 2.67102 9.31367 2.67102 6C2.67102 2.68633 5.35737 6.42331e-05 8.67102 0ZM34.671 0C37.9847 0 40.671 2.68629 40.671 6C40.671 9.31371 37.9847 12 34.671 12C31.3574 11.9999 28.671 9.31367 28.671 6C28.671 2.68633 31.3574 6.42331e-05 34.671 0Z"
        fill={disabled ? "#7E8591" : "url(#linear-gradient-024999-047AFF)"}
        fillOpacity={disabled ? 0.37 : 1}
      />
      <defs>
        <linearGradient
          id="linear-gradient-024999-047AFF"
          x1="11.6711"
          y1="28.5"
          x2="31.6711"
          y2="28.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#024999"/>
          <stop offset="1" stopColor="#047AFF"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default FriendIcon
